const messages = {
  title: "PRODUKT Prislister og brosjyrer",
  description:
    "Last ned de nyeste brosjyrene og flygebladene om våre Bridgestone- og Firestone-dekk til personbiler, SUV-er og varebiler her.",
  brochureCategories: {
    products: "Produkter",
    brand_and_solutions: "Merke og løsninger",
    season_and_promotions: "Sesong og kampanjer",
    format: "Format",
    cars_and_vans: "Personbil og varebil",
    summer: "Sommer",
    winter: "Vinter",
    promotions: "Kampanjer",
    all_season: "All sesong",
    truck_and_buses: "Lastebiler og busser",
    motorcycle: "Motorsykkel",
    agriculture: "Landbruk",
    construction_machinery: "Anleggsmaskiner",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materialer",
    brochures: "Produktbrosjyrer",
    price_list: "Prislister",
    materials: "Materialer",
    video_in_store: "Video med undertekster",
    video_online: "Video uten undertekster",
    banner_website: "Banner",
    banner_social_media: "Sosiale medier",
    logos: "Logoer",
  },
  searchMedia: "Skriv inn søkeord",
  searchResults: "Søkeresultater",
};

export default {
  messages,
};
